import { FILE, FILE_NAME, initialDocumentFileValues } from '../../fields'

export const getInitialValues = mediaProductAttachedFile => ({
  [FILE_NAME]: mediaProductAttachedFile[FILE_NAME] || '',
  ...initialDocumentFileValues,
  [FILE]: mediaProductAttachedFile[FILE] || ''
})
